import {
  Component,
  Input,
} from '@angular/core';
@Component({
  selector: 'app-dialpad',
  templateUrl: './dialpad.component.html',
  styleUrls: ['./dialpad.component.css'],
})
export class DialpadComponent  {
 
  phoneNumber: string = '';
  error: string = '';
  incomingCall: string = '';

  digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];


  addDigit(digit: string) {
    this.phoneNumber += digit;
  }

  deleteDigit() {
    if (this.phoneNumber.length > 0) {
      this.phoneNumber = this.phoneNumber.slice(0, -1);
    }
  }

  // async startRecording() {
  //   await this.sipService.startRecording();
  // }

  // stopRecording() {
  //   this.sipService.stopRecording();
  // }

  // async playRecording() {
  //   await this.sipService.playRecording();
  // }

  clearInput() {
    this.phoneNumber = '';
  }

}
